import { ActionType, ComponentType } from '../../enums';

export interface CreateSearchSuggestionClickEventPayloadOptions {
  componentVariant: 'property' | 'destination';
  itemId: string | null;
  itemName: string | null;
  itemText: string;
  count: number;
  searchRecent: string[];
  viewMode: 'list' | 'tile';
  index: number;
  url: string;
}

export interface CreateSearchSuggestionClickEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    group_name: string;
    component_variant: 'property' | 'destination';
    item_id: string | null;
    item_name: string | null;
    item_text: string;
    index: number;
    url: string;
    count: number;
    search_recent: string[];
    view_mode: 'list' | 'tile';
  };
}

export const createSearchSuggestionClickEventPayload = ({
  componentVariant,
  itemId,
  itemName,
  itemText,
  index,
  url,
  count,
  searchRecent,
  viewMode,
}: CreateSearchSuggestionClickEventPayloadOptions): CreateSearchSuggestionClickEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.CLICK,
      component_type: ComponentType.SEARCH,
      group_name: 'recent search',
      component_variant: componentVariant,
      item_id: itemId,
      item_name: itemName,
      item_text: itemText,
      index,
      url,
      count,
      search_recent: searchRecent,
      view_mode: viewMode,
    },
  };
};
